<div
    (mouseenter)="onMouseEnter($event)"
    (mouseleave)="onMouseLeave($event)"
    [matTooltip]="tooltip"
    class="fab-sub-tools"
    matTooltipClass="mat-tooltip-bigger"
    matTooltipPosition="left"
    matTooltipShowDelay="500"
>
    <button
        (click)="onActionClick($event)"
        (mouseenter)="onActionMouseEnter($event)"
        (mouseleave)="onActionMouseLeave($event)"
        [class.fab-sub-button-small]="smallFontEnabled"
        class="fab-sub-button"
        mat-mini-fab
    >
        <mat-icon *ngIf="!!actionIcon" [svgIcon]="actionIcon" style="height: 25px">{{ actionIcon }}</mat-icon>
        <mat-icon *ngIf="!!estensaIcon" [fontSet]="enableEstensaFontSet ? 'estensa-icons' : ''" style="height: 25px">{{
            estensaIcon
        }}</mat-icon>
    </button>
    <div [class.closed]="!isOpen" class="fab-sub-actions">
        <ng-content></ng-content>
    </div>
</div>
